/* istanbul ignore file */
import React from 'react';

import type { SettingsMetadataFilterProps } from './SettingsMetadataFilter';

const LazySettingsMetadataFilter = React.lazy(async () => {
    const resolved = await import(
        /* webpackChunkName: 'widget-community-list-settings-metadata-filter' */
        './SettingsMetadataFilter'
    );

    return { default: resolved.SettingsMetadataFilter };
});

export const SettingsMetadataFilter = (props: SettingsMetadataFilterProps) => {
    return (
        <React.Suspense fallback={null}>
            <LazySettingsMetadataFilter {...props} />
        </React.Suspense>
    );
};
